export const OSS_ENVS = {
  LOCAL: 'LOCAL',
  // bim local env
  QA: 'QA',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION'
};
export const OSS_BASE_URL = {
  [OSS_ENVS.LOCAL]: 'https://developer-stg.api.autodesk.com',
  [OSS_ENVS.QA]: 'https://developer-stg.api.autodesk.com',
  [OSS_ENVS.STAGING]: 'https://developer-stg.api.autodesk.com',
  [OSS_ENVS.PRODUCTION]: 'https://developer.api.autodesk.com'
};
export const OSS_BASE_PATH = '/oss/v2';
export const DEFAULT_FILE_CHUNK_SIZE = 5242880; // 5MB
/**
 * https://stackoverflow.com/questions/985431/max-parallel-http-connections-in-a-browser
 *
 * according to the stackoverflow, the ACC/BIM360 support browsers' https simultaneously connection is at least 6.
 * set "DEFAULT_HTTP_CONNECTION_COUNT = 4" and reserve buffer for other https consume.
 */
export const DEFAULT_HTTP_CONNECTION_LIMIT = 4;
export const DEFAULT_RETRY_TIMES = 3;

// UPLOAD_CONTENT_XXX includes get signed url and put content
export const UPLOAD_STATUS = {
  PENDING: 'PENDING',
  UPLOAD_CONTENT: 'UPLOAD_CONTENT',
  UPLOAD_CONTENT_SUCCESS: 'UPLOAD_CONTENT_SUCCESS',
  UPLOAD_CONTENT_FAILED: 'UPLOAD_CONTENT_FAILED',
  COMPLETE_UPLOAD_PENDING: 'COMPLETE_UPLOAD_PENDING',
  COMPLETE_UPLOAD: 'COMPLETE_UPLOAD',
  COMPLETE_UPLOAD_SUCCESS: 'COMPLETE_UPLOAD_SUCCESS',
  COMPLETE_UPLOAD_FAILED: 'COMPLETE_UPLOAD_FAILED'
};
export const ossCancelTokenMap = new Map();
export const ERROR = {
  // OBJECT_SIZE_EXCEED: 'OBJECT_SIZE_EXCEED', // more than 5TB
  // GET_STORAGE_FAILED: 'GET_STORAGE_FAILED', // call storage API failed
  READ_FILE_ERROR: 'READ_FILE_ERROR',
  READ_FILE_ABORTED: 'READ_FILE_ABORTED',
  FILE_INVALID: 'FILE_INVALID'
};

/* eslint-disable */
// https://docs.aws.amazon.com/AmazonS3/latest/userguide/qfacts.html
export const AWS_S3_FILE_SIZE_LIMIT = 5497558138880;
export const AWS_S3_FILE_CHUNK_LIMIT = 10000;
const SIGNED_S3_URL_LIMIT = 25; // https://wiki.autodesk.com/display/FDPA/API+Endpoints#APIEndpoints-GetUploadURL/s

// signed s3 url expired after 10 minutes.
// The custom expiration time within the 1 to 60 minutes range, if not specified, default is 2 minutes.
export const S3_URL_EXPIRED_DURATION = 10;
const FILE_EXPIRED_AFTER = 86400000; // file upload expired after 1 day
// Unused const end
/* eslint-enable */

export const AWS_S3_UPLOAD_URL_SIGNATURE = new RegExp('amazonaws.com/signed-url-uploads');